/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { subscriptionsGet } from "../../funcs/subscriptionsGet.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  subscriptionId: z.string(),
};

export const tool$subscriptionsGet: ToolDefinition<typeof args> = {
  name: "subscriptions-get",
  description: `Retrieve a subscription

Retrieve subscription details by ID. View status, billing cycle, customer info, and payment history.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await subscriptionsGet(
      client,
      args.subscriptionId,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
